import React from 'react'
import { Route, IndexRedirect, Redirect } from 'react-router'
import loadable from 'hoc/Loadable'
import {
  functionPath,
  functionEditCodePath,
  functionEditSettingsPath
} from 'lib/path-helpers/functions'
import WrapperPage from './pages/WrapperPage'

const NewPage = loadable(() =>
  import(/* webpackChunkName: "FunctionsNewPage" */ './pages/NewPage')
)
const ListPage = WrapperPage(
  loadable(() =>
    import(/* webpackChunkName: "FunctionsListPage" */ './pages/ListPage')
  )
)
const ViewPage = loadable(() =>
  import(/* webpackChunkName: "FunctionsViewPage" */ './pages/ViewPage')
)
const EditPage = loadable(() =>
  import(/* webpackChunkName: "FunctionsEditPage" */ './pages/EditPage')
)
const EditCodePage = loadable(() =>
  import(/* webpackChunkName: "FunctionsEditCodePage" */ './pages/EditCodePage')
)
const EditSettingsPage = loadable(() =>
  import(
    /* webpackChunkName: "FunctionsEditSettingsPage" */ './pages/EditSettingsPage'
  )
)

export default (
  <>
    <Route
      path="functions/catalog/new"
      pageName="New Function"
      component={NewPage}
      disableGlobalTopNav
      preload={[ListPage, ViewPage]}
    />
    <Route
      path="functions/catalog"
      disableGlobalTopNav
      pageName="Functions"
      label="Functions"
      component={ListPage}
      preload={[NewPage, ViewPage]}
    >
      <Route
        path=":functionId"
        component={ViewPage}
        preload={[EditPage, EditCodePage]}
      />
    </Route>
    <Route
      path="functions/catalog/:functionId/edit"
      disableGlobalTopNav
      pageName="Edit Function"
      label="Edit Function"
      component={EditPage}
    >
      <IndexRedirect to="code" />
      <Route
        path="code"
        pageName="Edit Function Code"
        component={EditCodePage}
        preload={[EditSettingsPage]}
      />
      <Route
        path="settings"
        pageName="Edit Function Settings"
        component={EditSettingsPage}
        preload={[EditCodePage]}
      />
    </Route>
    <Redirect from="build-v2/catalog/new" to="functions/catalog/new" />
    <Redirect from="build-v2/catalog" to="functions/catalog" />
    <Route
      path="build-v2/catalog/:functionId"
      disableGlobalTopNav
      component={({ router, params }) => {
        router.push(functionPath(params))
        return null
      }}
    />
    <Route
      path="build-v2/catalog/:functionId/edit"
      disableGlobalTopNav
      component={({ router, params }) => {
        router.push(functionEditCodePath(params))
        return null
      }}
    />
    <Route
      path="build-v2/catalog/:functionId/edit/code"
      disableGlobalTopNav
      component={({ router, params }) => {
        router.push(functionEditCodePath(params))
        return null
      }}
    />
    <Route
      path="build-v2/catalog/:functionId/edit/settings"
      disableGlobalTopNav
      component={({ router, params }) => {
        router.push(functionEditSettingsPath(params))
        return null
      }}
    />
  </>
)
